import { Common, color } from '@stockbit/ui';
import number from 'utils/number';

const { Flex, Text } = Common;

interface ProfileStatsProp {
  label: string;
  icon?: string;
  value: string | number;
}

function ProfileStatsAttribute({ value, label }: ProfileStatsProp) {
  const formattedValue = String(
    // @ts-ignore
    number.numberFormatter({
      num: Number(value),
      fixed: 1,
      withThousands: true,
      formatDot: '0,0.0',
    }),
  );

  return (
    <Flex direction="column">
      <Flex direction="row" align="baseline">
        <Text family="bold" size="16px" padding="0 4px 0 0">
          {formattedValue.split(' ').join('').toLowerCase()}
        </Text>
        <Text size="14px" color={color.highgray}>
          {label}
        </Text>
      </Flex>
    </Flex>
  );
}

export default ProfileStatsAttribute;
